import React from 'react';
import { Check, X } from 'lucide-react';
const beforeItems = ['Stundenlange Planung jeder einzelnen Sportstunde', 'Immer wieder dieselben Spiele und Übungen', 'Keine klare Progression über das Schuljahr', 'Unsicherheit bei Bewertung und Beobachtung', 'Stress bei Vertretung, Regen oder belegter Sporthalle', 'Schüler unmotiviert, unruhig oder sitzen zu lange herum', 'Du musst alles selbst zusammensuchen'];
const afterItems = ['5 Minuten Überblick — und du bist bereit für die Sporthalle', 'Fertige Stunden mit Ziel, Material, Ablauf und Varianten', 'Klare Jahresstruktur von Klasse 1 bis Klasse 12', 'Bewertungsraster, Beobachtungsbögen und Reflexionsfragen', 'Sofort nutzbare Notfallstunden und Minimal-Material-Lösungen', 'Mehr Bewegung, mehr Ordnung, mehr Motivation', 'Alles als PDF — speichern, drucken, mitnehmen'];
const bottomStats = [{
  num: '+480',
  label: 'Sportstunden'
}, {
  num: '12',
  label: 'Bände'
}, {
  num: '100%',
  label: 'Downloadbar'
}];
export function ContrastSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-38">
      <div className="max-w-5xl mx-auto" data-id="element-39">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center mb-16" data-id="element-40">
          {/* Left side */}
          <div data-id="element-41">
            <h2 className="text-4xl sm:text-5xl font-serif font-black text-text-main mb-6 leading-tight" data-id="element-42">
              Vom überlasteten Sportlehrer zum{' '}
              <span className="text-primary italic" data-id="element-43">
                perfekt vorbereiteten Unterrichtsprofi.
              </span>
            </h2>
            <p className="text-text-sec text-base sm:text-lg font-medium leading-relaxed mb-6" data-id="element-44">
              Du musst nicht mehr jeden Sonntagabend überlegen, was du am Montag
              in der Sporthalle machen sollst. Mit SPORTUNTERRICHT FERTIG
              bekommst du ein vollständiges System, das dir Struktur, Klarheit
              und sofort einsetzbare Sportstunden liefert.
            </p>
          </div>

          {/* Right side - Comparison Table */}
          <div className="bg-bg-alt rounded-3xl border border-border-light overflow-hidden shadow-sm" data-id="element-45">
            <div className="grid grid-cols-2 divide-x divide-border-light" data-id="element-46">
              {/* Before */}
              <div className="p-6 sm:p-8 bg-red-50/30" data-id="element-47">
                <h3 className="text-secondary font-bold text-xs sm:text-sm uppercase tracking-wider mb-6 flex items-center gap-2" data-id="element-48">
                  <span className="w-6 h-6 rounded-full bg-secondary/10 flex items-center justify-center" data-id="element-49">
                    <X className="w-3 h-3" data-id="element-50" />
                  </span>
                  Vorher
                </h3>
                <ul className="space-y-4" data-id="element-51">
                  {beforeItems.map((item, i) => <li key={i} className="text-text-sec text-sm sm:text-base flex items-start gap-2" data-id="element-52">
                      <X className="w-4 h-4 text-secondary/60 flex-shrink-0 mt-1" data-id="element-53" />
                      <span data-id="element-54">{item}</span>
                    </li>)}
                </ul>
              </div>

              {/* After */}
              <div className="p-6 sm:p-8 bg-primary/5" data-id="element-55">
                <h3 className="text-primary font-bold text-xs sm:text-sm uppercase tracking-wider mb-6 flex items-center gap-2" data-id="element-56">
                  <span className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-57">
                    <Check className="w-3 h-3" data-id="element-58" />
                  </span>
                  Mit SPORTUNTERRICHT FERTIG
                </h3>
                <ul className="space-y-4" data-id="element-59">
                  {afterItems.map((item, i) => <li key={i} className="text-text-main font-medium text-sm sm:text-base flex items-start gap-2" data-id="element-60">
                      <Check className="w-4 h-4 text-primary flex-shrink-0 mt-1" data-id="element-61" />
                      <span data-id="element-62">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom stats */}
        <div className="grid grid-cols-3 gap-4 sm:gap-6 max-w-3xl mx-auto" data-id="element-63">
          {bottomStats.map((s, i) => <div key={i} className="bg-bg-alt border border-border-light rounded-2xl p-4 sm:p-6 text-center shadow-sm" data-id="element-64">
              <p className="text-primary font-serif font-black text-2xl sm:text-4xl mb-1" data-id="element-65">
                {s.num}
              </p>
              <p className="text-text-sec text-xs sm:text-sm font-medium uppercase tracking-wider" data-id="element-66">
                {s.label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}